import React from 'react';
import { Check, Sparkles, ArrowRight, Shield } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { Tabs } from '../ui/Tabs';
import { AnimatedSection } from './AnimatedSection';
import { useCart } from '../../contexts/CartContext';
import { pricingCards, cardAccents, packagesData } from './homeData';
interface PricingSectionProps {
  onNavigate: (page: string) => void;
}
export function PricingSection({
  onNavigate
}: PricingSectionProps) {
  const {
    addItem
  } = useCart();
  const handleBuyPackage = (pkg: {
    title: string;
    desc: string;
    price: string;
    oldPrice?: string | null;
  }) => {
    const priceNum = parseInt(pkg.price.replace(/[^\d]/g, ''));
    const oldPriceNum = pkg.oldPrice ? parseInt(pkg.oldPrice.replace(/[^\d]/g, '')) : undefined;
    addItem({
      id: `pkg-${Date.now()}`,
      name: pkg.title,
      description: pkg.desc,
      price: priceNum,
      type: 'package',
      format: 'PDF-отчёты',
      duration: 'Бессрочно',
      oldPrice: oldPriceNum,
      badges: [{
        label: 'Пакет отчётов',
        variant: 'success'
      }]
    });
    onNavigate('checkout');
  };
  const singlePricing = <div data-id="element-13663">
      <div className="relative mt-6" data-id="element-13664">
        <div className="xl:hidden absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-13665" />
        <div className="xl:hidden absolute right-0 top-0 bottom-0 w-4 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-13666" />
        <div className="flex gap-3 overflow-x-auto xl:overflow-x-visible pb-4 xl:pb-0 snap-x snap-mandatory xl:snap-none -mx-1 px-1 xl:mx-0 xl:px-0 xl:grid xl:grid-cols-5" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-13667">
          {pricingCards.map((card, idx) => {
          const accent = cardAccents[idx];
          if (card.popular) {
            return <div key={idx} className="flex-shrink-0 w-[240px] xl:w-auto snap-center pt-4" data-id="element-13668">
                  <div className="relative h-full" data-id="element-13669">
                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10" data-id="element-13670">
                      <span className="bg-white text-indigo-600 text-[11px] font-bold px-3 py-1 rounded-full shadow-lg flex items-center gap-1 whitespace-nowrap" data-id="element-13671">
                        <Sparkles className="w-3 h-3" data-id="element-13672" />
                        Популярно
                      </span>
                    </div>
                    <div className="bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-600 rounded-2xl p-4 xl:p-5 flex flex-col h-full shadow-xl shadow-indigo-500/20" data-id="element-13673">
                      <div className={`w-10 h-10 rounded-lg ${accent.iconBg} flex items-center justify-center mb-3 mt-1`} data-id="element-13674">
                        {accent.icon}
                      </div>
                      <h3 className="text-[15px] font-bold text-white mb-1 leading-tight" data-id="element-13675">
                        {card.title}
                      </h3>
                      <p className="text-indigo-200 text-xs mb-3 flex-grow leading-relaxed" data-id="element-13676">
                        {card.desc}
                      </p>
                      <ul className="space-y-1.5 mb-4 text-xs text-indigo-100" data-id="element-13677">
                        {card.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-13678">
                            <div className={`w-3.5 h-3.5 rounded-full ${accent.checkBg} flex items-center justify-center mr-1.5 flex-shrink-0`} data-id="element-13679">
                              <Check className={`w-2 h-2 ${accent.checkText}`} data-id="element-13680" />
                            </div>
                            {f}
                          </li>)}
                      </ul>
                      <div className="flex items-baseline gap-1.5 mb-0.5" data-id="element-13681">
                        <span className="text-xl font-bold text-white" data-id="element-13682">
                          {card.price}
                        </span>
                        <span className="text-xs text-indigo-200 line-through" data-id="element-13683">
                          {card.oldPrice}
                        </span>
                      </div>
                      <span className="text-[11px] font-semibold text-emerald-300 mb-3" data-id="element-13684">
                        Выгода 17%
                      </span>
                      <Button fullWidth variant="outline" className="!bg-white !text-indigo-600 !border-white/30 hover:!bg-indigo-50 text-sm py-2" onClick={() => onNavigate(card.route)} data-id="element-13685">
                        Выбрать
                      </Button>
                    </div>
                  </div>
                </div>;
          }
          return <div key={idx} className="flex-shrink-0 w-[240px] xl:w-auto snap-center pt-4" data-id="element-13686">
                <div className={`relative bg-gradient-to-b ${accent.tint} to-white rounded-2xl border border-slate-200/80 border-t-2 ${accent.border} p-4 xl:p-5 h-full flex flex-col`} data-id="element-13687">
                  <div className={`w-10 h-10 rounded-lg ${accent.iconBg} flex items-center justify-center mb-3`} data-id="element-13688">
                    {accent.icon}
                  </div>
                  <h3 className="text-[15px] font-bold text-slate-900 mb-1 leading-tight" data-id="element-13689">
                    {card.title}
                  </h3>
                  <p className="text-slate-500 text-xs mb-3 flex-grow leading-relaxed" data-id="element-13690">
                    {card.desc}
                  </p>
                  <ul className="space-y-1.5 mb-4 text-xs text-slate-600" data-id="element-13691">
                    {card.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-13692">
                        <div className={`w-3.5 h-3.5 rounded-full ${accent.checkBg} flex items-center justify-center mr-1.5 flex-shrink-0`} data-id="element-13693">
                          <Check className={`w-2 h-2 ${accent.checkText}`} data-id="element-13694" />
                        </div>
                        {f}
                      </li>)}
                  </ul>
                  <div className="text-xl font-bold text-slate-900 mb-3" data-id="element-13695">
                    {card.price}
                  </div>
                  <Button fullWidth variant="outline" className="text-sm py-2" onClick={() => onNavigate(card.route)} data-id="element-13696">
                    Выбрать
                  </Button>
                </div>
              </div>;
        })}
        </div>
      </div>
      <div className="text-center mt-5" data-id="element-13697">
        <Button variant="ghost" className="text-slate-500" onClick={() => onNavigate('pricing')} data-id="element-13698">
          Все цены и услуги <ArrowRight className="ml-2 w-4 h-4" data-id="element-13699" />
        </Button>
      </div>
    </div>;
  const packagesPricing = <div data-id="element-13700">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-8 max-w-4xl mx-auto" data-id="element-13701">
        {packagesData.map((pkg, idx) => <div key={idx} className={pkg.popular ? 'pt-4' : 'pt-0 md:pt-4'} data-id="element-13702">
            {pkg.popular ? <div className="relative h-full" data-id="element-13703">
                <div className="absolute -inset-[1px] bg-gradient-to-b from-indigo-500 via-violet-500 to-indigo-600 rounded-2xl" data-id="element-13704" />
                <div className="absolute -top-3.5 left-1/2 transform -translate-x-1/2 z-10" data-id="element-13705">
                  <span className="bg-gradient-to-r from-indigo-600 to-violet-600 text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-lg shadow-indigo-500/25 flex items-center gap-1.5" data-id="element-13706">
                    <Sparkles className="w-3 h-3" data-id="element-13707" />
                    Самый популярный
                  </span>
                </div>
                <div className="relative bg-white rounded-2xl p-7 flex flex-col h-full" data-id="element-13708">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-13709">
                    {pkg.title}
                  </h3>
                  <p className="text-slate-500 mb-4 flex-grow text-sm leading-relaxed" data-id="element-13710">
                    {pkg.desc}
                  </p>
                  <ul className="space-y-2.5 mb-6 text-sm text-slate-600" data-id="element-13711">
                    {pkg.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-13712">
                        <div className="w-5 h-5 rounded-full bg-emerald-50 flex items-center justify-center mr-2.5 flex-shrink-0" data-id="element-13713">
                          <Check className="w-3 h-3 text-emerald-500" data-id="element-13714" />
                        </div>
                        {f}
                      </li>)}
                  </ul>
                  <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-13715">
                    {pkg.price}
                  </div>
                  <div className="flex items-center gap-2 mb-6" data-id="element-13716">
                    <span className={`text-xs font-bold ${pkg.perUnitColor}`} data-id="element-13717">
                      {pkg.perUnit}
                    </span>
                    {pkg.savings && <span className="text-[10px] font-bold text-white bg-indigo-500 px-2 py-0.5 rounded-full" data-id="element-13718">
                        {pkg.savings}
                      </span>}
                  </div>
                  <Button fullWidth onClick={() => handleBuyPackage(pkg)} data-id="element-13719">
                    Купить пакет
                  </Button>
                </div>
              </div> : <Card padding="none" className="flex flex-col h-full border-slate-200/80" data-id="element-13720">
                <div className="p-7 flex flex-col h-full" data-id="element-13721">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-13722">
                    {pkg.title}
                  </h3>
                  <p className="text-slate-500 mb-4 flex-grow text-sm leading-relaxed" data-id="element-13723">
                    {pkg.desc}
                  </p>
                  <ul className="space-y-2.5 mb-6 text-sm text-slate-600" data-id="element-13724">
                    {pkg.features.map((f, i) => <li key={i} className="flex items-center" data-id="element-13725">
                        <div className="w-5 h-5 rounded-full bg-emerald-50 flex items-center justify-center mr-2.5 flex-shrink-0" data-id="element-13726">
                          <Check className="w-3 h-3 text-emerald-500" data-id="element-13727" />
                        </div>
                        {f}
                      </li>)}
                  </ul>
                  <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-13728">
                    {pkg.price}
                  </div>
                  <div className="flex items-center gap-2 mb-6" data-id="element-13729">
                    <span className={`text-xs font-bold ${pkg.perUnitColor}`} data-id="element-13730">
                      {pkg.perUnit}
                    </span>
                    {pkg.savings && <span className="text-[10px] font-bold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full" data-id="element-13731">
                        {pkg.savings}
                      </span>}
                  </div>
                  <Button fullWidth variant="outline" onClick={() => handleBuyPackage(pkg)} data-id="element-13732">
                    Купить пакет
                  </Button>
                </div>
              </Card>}
          </div>)}
      </div>
    </div>;
  const pricingTabs = [{
    id: 'single',
    label: 'Разово',
    content: singlePricing
  }, {
    id: 'packages',
    label: 'Пакеты',
    content: packagesPricing
  }];
  return <AnimatedSection className="py-8 sm:py-16 bg-white" data-id="element-13733">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13734">
        <div className="text-center mb-4 sm:mb-8" data-id="element-13735">
          <div className="inline-flex items-center px-3 sm:px-4 py-1 sm:py-1.5 rounded-full bg-slate-100 text-slate-600 text-[10px] sm:text-xs font-semibold uppercase tracking-[0.15em] mb-3 sm:mb-4" data-id="element-13736">
            <Shield className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1.5 sm:mr-2" data-id="element-13737" />
            Прозрачные цены
          </div>
          <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-13738">
            Тарифы и пакеты
          </h2>
          <p className="text-xs sm:text-lg text-slate-500 max-w-xl mx-auto" data-id="element-13739">
            Простые цены без скрытых платежей. Гарантия возврата 7 дней.
          </p>
        </div>
        <Tabs tabs={pricingTabs} defaultTab="single" className="mb-6 sm:mb-10" data-id="element-13740" />
      </div>
    </AnimatedSection>;
}